import Swiper, {Navigation, Pagination, Thumbs, Autoplay, Keyboard} from 'swiper/core';

Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Keyboard]);

class MainSwiper {
    constructor(swiperContainer) {
        this.swiperGalleryEle = swiperContainer.querySelector('.js-is-swiper__main');
        this.swiperThumbsEle = swiperContainer.querySelector('.js-is-swiper__main--thumbs');
        this.autoplay = swiperContainer.dataset.autoplay === '1';
        this.delay = swiperContainer.dataset.delay;
    }

    makeThumbs() {
        let swiperWrapperEle = $('.swiper-wrapper', this.swiperThumbsEle);
        $('.swiper-slide', this.swiperGalleryEle).each(
            (index, swiperSlider) => {
                if(swiperSlider.hasAttribute('data-title')) {
                    swiperWrapperEle.append('<span class="swiper-slide">' + swiperSlider.dataset.title.trim() + '</span>')
                } else {
                    swiperWrapperEle.append('<span class="swiper-slide">-</span>')
                }
            }
        );
    }

    swiper() {

        if(this.swiperThumbsEle) {
            this.makeThumbs();
        }

        let galleryThumbs = new Swiper(this.swiperThumbsEle, {
            spaceBetween: 1,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            resizeObserver: false,
            watchOverflow: true,
            threshold: 30,
        });

        let galleryTop = new Swiper(this.swiperGalleryEle, {
            // Navigation arrows
            resizeObserver: false,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.js-swiper-button-next',
                prevEl: '.js-swiper-button-prev',
            },
            pagination: {
                el: '.is-swiper-pagination',
                clickable: true
            },
            spaceBetween: 0,
            thumbs: {
                 swiper: this.swiperThumbsEle ? galleryThumbs : false
            },
            threshold: 30,
        });

        if(this.delay) {
            galleryTop.params.autoplay.delay = this.delay;
            galleryTop.autoplay.start();
        }


    }
}


window.addEventListener('load', () => {
    // init Swiper:
    $('.is-swiper--main').each((index, swiperContainer) => {
        new MainSwiper(swiperContainer).swiper();
    });

}, false);
